var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "d-flex align-start" },
    [
      _c(
        "v-icon",
        {
          staticClass: "techStatus mr-2 pa-1",
          style: `background-color: ${_vm.status.color};`,
          attrs: { color: "#fff", "x-small": "" }
        },
        [_vm._v("\n    " + _vm._s(_vm.status.icon) + "\n  ")]
      ),
      _vm._v(" "),
      _vm.status.waiting
        ? _c(
            "div",
            [
              _vm.isOrdo || _vm.status.label === "DI"
                ? _c(
                    "v-tooltip",
                    {
                      attrs: { bottom: "" },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "activator",
                            fn: function({ on }) {
                              return [
                                _c("div", _vm._g({}, on), [
                                  _vm._v(
                                    "\n          " +
                                      _vm._s(_vm.displayPlanifDate()) +
                                      "\n        "
                                  )
                                ])
                              ]
                            }
                          }
                        ],
                        null,
                        false,
                        1872644091
                      )
                    },
                    [
                      _vm._v(" "),
                      _c("span", [
                        _vm._v(
                          "\n        " + _vm._s(_vm.date.hour) + "\n      "
                        )
                      ])
                    ]
                  )
                : _c("div", [
                    _vm._v(
                      "\n      " + _vm._s(_vm.displayPlanifDate()) + "\n    "
                    )
                  ])
            ],
            1
          )
        : _vm.status.color
        ? _c("div", [_vm._v("\n    " + _vm._s(_vm.status.label) + "\n  ")])
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }